export const setLoginData = (ac,tk) => ({
    type: 'LOGIN',
    ac: ac,
    tk: tk
})